var generateStyle = function generateStyle() {
  return {
    itemBody: {
      cursor: 'pointer',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'pre-wrap'
    }
  };
};
export default generateStyle;